import { render, staticRenderFns } from "./CatTable.vue?vue&type=template&id=9c6a5240&scoped=true&"
import script from "./CatTable.vue?vue&type=script&lang=ts&"
export * from "./CatTable.vue?vue&type=script&lang=ts&"
import style0 from "./CatTable.vue?vue&type=style&index=0&id=9c6a5240&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6a5240",
  null
  
)

export default component.exports